"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BACKOFFICE_PERMISSION = exports.STUDENT_PERMISSION = exports.DELETE_STEPS_PI = exports.EDIT_STEPS_PI = exports.CREATE_STEPS_PI = exports.ORDER_STEPS_PI = exports.VIEW_STEPS_PI = exports.EDIT_PI = exports.CREATE_PI = exports.NAVIGATE_PI = exports.DELETE_ROLES = exports.EDIT_ROLES = exports.CREATE_ROLE = exports.NAVIGATE_ROLES = exports.CREATE_USER = exports.EDIT_USER = exports.CHANGE_PASSWORD_USER = exports.VIEW_USER = exports.NAVIGATE_USER = exports.CLONE_EXERCISE = exports.CREATE_EXERCISE = exports.EDIT_EXERCISE = exports.VIEW_EXERCISE = exports.NAVIGATE_EXERCISE = exports.CREATE_QUIZ = exports.EDIT_QUIZ = exports.VIEW_QUIZ = exports.NAVIGATE_QUIZ = exports.CREATE_INSTITUTE = exports.EDIT_INSTITUTE = exports.VIEW_INSTITUTE = exports.NAVIGATE_INSTITUTE = exports.NAVIGATE_COURSE = exports.CLONE_COURSE = exports.CREATE_COURSE = exports.FULL_COURSE_ACCESS = void 0;
const granters_1 = require("./granters");
const { oneOf } = granters_1.checkIsLoggedWithPermission;
/**
 * COURSES
 */
exports.FULL_COURSE_ACCESS = oneOf(['FULL_COURSE_ACCESS']);
exports.CREATE_COURSE = oneOf(['CREATE_COURSE']);
exports.CLONE_COURSE = oneOf(['CLONE_COURSE']);
exports.NAVIGATE_COURSE = oneOf(['NAVIGATE_COURSE']);
/**
 * INSTITUTES
 */
exports.NAVIGATE_INSTITUTE = oneOf(['NAVIGATE_INSTITUTE']);
exports.VIEW_INSTITUTE = oneOf(['VIEW_INSTITUTE']);
exports.EDIT_INSTITUTE = oneOf(['EDIT_INSTITUTE']);
exports.CREATE_INSTITUTE = oneOf(['CREATE_INSTITUTE']);
/**
 * QUIZZES
 */
exports.NAVIGATE_QUIZ = oneOf(['NAVIGATE_QUIZ']);
exports.VIEW_QUIZ = oneOf(['VIEW_QUIZ']);
exports.EDIT_QUIZ = oneOf(['EDIT_QUIZ']);
exports.CREATE_QUIZ = oneOf(['CREATE_QUIZ']);
/**
 * EXERCISES
 */
exports.NAVIGATE_EXERCISE = oneOf(['NAVIGATE_EXERCISE']);
exports.VIEW_EXERCISE = oneOf(['VIEW_EXERCISE']);
exports.EDIT_EXERCISE = oneOf(['EDIT_EXERCISE']);
exports.CREATE_EXERCISE = oneOf(['CREATE_EXERCISE']);
exports.CLONE_EXERCISE = oneOf(['CLONE_EXERCISE']);
/**
 * USERS
 */
exports.NAVIGATE_USER = oneOf(['NAVIGATE_USER']);
exports.VIEW_USER = oneOf(['VIEW_USER']);
exports.CHANGE_PASSWORD_USER = oneOf(['CHANGE_PASSWORD_USER']);
exports.EDIT_USER = oneOf(['EDIT_USER']);
exports.CREATE_USER = oneOf(['CREATE_USER']);
/**
 * ROLES
 */
exports.NAVIGATE_ROLES = oneOf(['NAVIGATE_ROLES']);
exports.CREATE_ROLE = oneOf(['CREATE_ROLE']);
exports.EDIT_ROLES = oneOf(['EDIT_ROLES']);
exports.DELETE_ROLES = oneOf(['DELETE_ROLES']);
/**
 * INTEGRATING PROJECTS
 */
exports.NAVIGATE_PI = oneOf(['NAVIGATE_INTEGRATING_PROJECTS']);
exports.CREATE_PI = oneOf(['CREATE_INTEGRATING_PROJECTS']);
exports.EDIT_PI = oneOf(['EDIT_INTEGRATING_PROJECTS']);
exports.VIEW_STEPS_PI = oneOf(['VIEW_INTEGRATING_PROJECTS_STEPS']);
exports.ORDER_STEPS_PI = oneOf(['ORDER_INTEGRATING_PROJECTS_STEPS']);
exports.CREATE_STEPS_PI = oneOf(['CREATE_INTEGRATING_PROJECTS_STEPS']);
exports.EDIT_STEPS_PI = oneOf(['EDIT_INTEGRATING_PROJECTS_STEPS']);
exports.DELETE_STEPS_PI = oneOf(['DELETE_INTEGRATING_PROJECTS_STEPS']);
/**
 * GUARDS
 */
exports.STUDENT_PERMISSION = oneOf(['STUDENT_PERMISSION']);
exports.BACKOFFICE_PERMISSION = oneOf(['BACKOFFICE_PERMISSION']);
